<template>
  <ul class="daelseec">
    <li v-for="(item, index) in classes" :key="index">
      <h2>{{ item.carNo }}</h2>
      <p v-for="(x, index) in JSON.parse(item.classesList)" :key="index">
        <span>{{ x.startTime }}-{{ x.endTime }} / {{ item.manager }}</span>
      </p>
    </li>
  </ul>
</template>
<script>
export default {
  props: ["classes"]
};
</script>
<style lang="">
.daelseec h2 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 4px;
}
.daelseec li:first-child {
  margin-top: 0;
}
.daelseec li {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/carsys/clzypb.vue